$(document).ready(function() {
  $('#Sms_phone').keydown(function() {
    $('#Sms_code').attr('disabled','disabled').css('background','#EEE');
    $('.btn-sign-in').html(translate.resend_message);
  })

});
